/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

export const NoFeeDayProps = PropTypes.shape({
    name: PropTypes.string,
    date: PropTypes.string,
});

export const NoFeeDayDefaults = {
    name: '',
    date: '',
};

export const NoFeeDaysProps = PropTypes.arrayOf(NoFeeDayProps);

export const NoFeeDaysDefaults = [];
